<template>
    <LayoutDefault>
        <div
            class="container"
            id="model_index"
        >
            <section class="categories">
                <h3 class="title">
                    {{$t('webstars.header_following')}}
                </h3>
              <ModelsContainer
                :following="true"
                :resultsPerPage = "resultsPerPage"
              />
            </section>

            <section class="categories">
                <h3 class="title">
                    {{$t('webstars.header_to_following')}}
                </h3>
              <ModelsContainer
                :following="false"
                :resultsPerPage = "resultsPerPage"
              />
            </section>
        </div>
    </LayoutDefault>
</template>

<script>
import ModelBox from '../components/ModelBox';
import Spinner from '../components/Spinner';
import EventBus from '../eventbus';
import LayoutDefault from "../layouts/LayoutDefault";
import _ from "lodash";
import ModelsContainer from "../components/ModelsContainer";

export default {
    components: {
        ModelsContainer,
        LayoutDefault,
        ModelBox,
        Spinner,
    },
    data(){
      return {
        resultsPerPage: 18,
      };
    },
    mounted(){
      this.loadMoreForInfiniteScroll();
    },
    methods: {
      // proper implementation - do not use arrow function // debounce o throttle
      endOfScrollPageReached:_.throttle(function(){
        EventBus.$emit('webstarEndOfScrollPageReached');
      }, 500),
      loadMoreForInfiniteScroll() {
        window.onscroll = () => {
          let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            this.endOfScrollPageReached();
          }
        }
      },
    },
}
</script>

<style scoped lang="scss">
@import '../styles/variables';

#model_index{
    background-color: $pallete_clear_color;
    min-height: 500px;
    padding: 9px;
}
</style>
